const user = JSON.parse(localStorage.getItem('user'))
var homePage = '/auth/login'
if (user) {
    homePage = user.homePage
}

import StaffingRoutes from './StaffingRoutes'
import SurveyRoutes from './SurveyRoutes'
import AnnouncementRoutes from './Announcement'
import AssetRoutes from './AssetRoutes'
import OnlineAttendanceRoutes from './OnlineAttendanceRoutes'
import TimeAttendanceRoutes from './TimeAttendanceRoutes'
import LeaveRoutes from './LeaveRoutes'
import OvertimeRoutes from './OvertimeRoutes'
import PayrollRoutes from './PayrollRoutes'
import PerformanceRoutes from './PerformanceRoutes'
import SettingRoutes from './SettingRoutes'
import ReportRoutes from './ReportRoutes'
import { Component } from '@fullcalendar/core/preact'
import FrameRoutes from './FrameRoutes'

const MainRoutes = {
    path: '/',
    component: () => import('@/layouts/full/FullLayout.vue'),
    redirect: homePage,
    meta: { requiresAuth: true },
    children: [
        ...StaffingRoutes,
        ...SurveyRoutes,
        ...AnnouncementRoutes,
        ...AssetRoutes,
        ...TimeAttendanceRoutes,
        ...OnlineAttendanceRoutes,
        ...LeaveRoutes,
        ...OvertimeRoutes,
        ...PayrollRoutes,
        ...PerformanceRoutes,
        ...SettingRoutes,
        ...ReportRoutes,
        ...FrameRoutes,
        {
            name: 'Dashboard2',
            path: '/dashboard',
            component: () => import('@/views/dashboard/DashboardView.vue'),
        },

        {
            path: '/admin/allusers',
            name: 'allusers',
            component: () => import('@/views/Admin/AllUserView.vue'),
        },
        {
            path: '/user/list',
            name: 'user-list',
            component: () => import('@/views/User/UserListView.vue'),
        },
        {
            path: '/user/request-update',
            name: 'request-update',
            component: () => import('@/views/User/UserRequestUpdateView.vue'),
        },
        {
            path: '/match-schedule',
            name: 'MatchSchedule',
            component: () => import('@/views/MatchRecord/MatchTable.vue'),
        },
        {
            path: '/match-setup',
            name: 'MatchSetup',
            component: () => import('@/views/MatchRecord/MatchSetup.vue'),
        },
        {
            path: '/error',
            name: 'error',
            component: () => import('@/views/authentication/Error.vue'),
        },
    ],
}

export default MainRoutes
